// extracted by mini-css-extract-plugin
export var formContainer = "_hq-0";
export var message = "_hq-1";